export default {
  methods: {
    /**
     * @param {boolean} isVisible
     */
    setLoader(isVisible = true) {
      const loaderSelector = 'page__loader';
      const classList = document.querySelector(`.${loaderSelector}`).classList;
      const className = `${loaderSelector}--visible`;

      if (isVisible) {
        classList.add(className);
      } else {
        classList.remove(className);
      }
    },
  },
};
